import { render } from "./IsolationPackageAdvice.vue?vue&type=template&id=a6b8d34c&scoped=true"
import script from "./IsolationPackageAdvice.vue?vue&type=script&lang=js"
export * from "./IsolationPackageAdvice.vue?vue&type=script&lang=js"

import "./IsolationPackageAdvice.vue?vue&type=style&index=0&id=a6b8d34c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6b8d34c"]])

export default __exports__